import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { AppWithDeveloperContext } from 'app/App.component';

ReactDOM.render(
  <React.StrictMode>
    <AppWithDeveloperContext />
  </React.StrictMode>,
  document.getElementById('eabd-d1-root')
);
